{
  "resourceType": "ValueSet",
  "status": "draft",
  "name": "ProcedurePerformerRoleValueSet",
  "id": "procedure-performer-role-vs",
  "title": "Panel Health Procedure Performer Role Value Set",
  "description": "Allowed Panel Health procedure performer role values.",
  "version": "0.0.1",
  "url": "https://casetech.app/fhir/ValueSet/procedure-performer-role-vs",
  "compose": {
    "include": [
      {
        "system": "https://casetech.app/fhir/CodeSystem/procedure-performer-role"
      }
    ]
  }
}
